import React from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Button, } from 'react-bootstrap';
import SearchBar from '../../searchbar/SearchBar';
import FieldSet from '../../fieldset/FieldSet';
import Grid from '../../grid/Grid';
import IntegrationPaymentBlasterService from '../../../service/IntegrationPaymentBlasterService';
import IPBSLineItemPaymentRecordModal from './IPBSLineItemPaymentRecordModal';
import IPBSDetailedPayableModal from './IPBSDetailedPayableModal';

class IPBSView extends React.Component {
  constructor(props) {
    super(props);
    const state = {};

    this.comboFields = [
      {
        value: 'customerId',
        display: 'Customer Id',
      },
      {
        value: 'payableId',
        display: 'Payable Id',
      },
    ];
    this.state = state;
  }

  static lineItemExclusions = [ 'payableAtTimeOfPayment', ];

  onReset() {
    this.onLineItemPaymentReset();
    this.onPayableReset();
  }

  onLineItemPaymentReset() {
    this.setState({
      selectedLineItemPaymentRecord: null,
      lineItemPaymentRecordHeaders: [],
      lineItemPaymentRecordRows: [],
    });
  }

  onPayableReset() {
    this.setState({
      selectedPayable: null,
      payableHeaders: [],
      payableRows: [],
    });
  }

  getLineItemPaymentsByCustomerId({ serviceOfferingId, customerId, }, onCompletion) {
    this.onReset();

    IntegrationPaymentBlasterService.getLineItemPaymentsByCustomerId({ serviceOfferingId, customerId, })
      .then((response) => {
        const { lineItemPaymentRecords, } = response.data.service;
        this.setLineItemValues(lineItemPaymentRecords);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  }

  getLineItemPaymentRecordsByPayableId({ serviceOfferingId, payableId, }, onCompletion) {
    this.onReset();

    IntegrationPaymentBlasterService.getLineItemPaymentRecordsByPayableId({ serviceOfferingId, payableId, })
      .then((response) => {
        const { lineItemPaymentRecords, } = response.data.service;
        this.setLineItemValues(lineItemPaymentRecords);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        onCompletion();
      });
  }

  setLineItemValues(lineItemPaymentRecords) {
    const model = Grid.toModelFromList(lineItemPaymentRecords, {
      headerFormatter: value => _.startCase(value.header),
      filter: value => !IPBSView.lineItemExclusions.includes(value),
    });

    this.setState({
      lineItemPaymentRecordHeaders: model.headers,
      lineItemPaymentRecordRows: model.format(lineItemPaymentRecords),
    });
  }

  searchOnClick(event) {
    const { combo = {}, search = {}, } = event;
    const { serviceOfferingId, } = this.props;
    if (combo.value === 'customerId') {
      this.getLineItemPaymentsByCustomerId({
        serviceOfferingId,
        customerId: search.value,
      }, event.kill);
    } else {
      this.getLineItemPaymentRecordsByPayableId({
        serviceOfferingId,
        payableId: search.value,
      }, event.kill);
    }
  }

  onRowSelect(selectedRow) {
    const { lineItemPaymentRecordRows, selectedLineItemPaymentRecord, } = this.state;
    if (!selectedLineItemPaymentRecord || selectedRow._id !== selectedLineItemPaymentRecord._id) {
      this.onPayableReset();
      const lineItemPaymentRecord = lineItemPaymentRecordRows.find((row) => {
        const { raw, } = row;
        return raw._id === selectedRow._id;
      });
      this.setState({
        selectedLineItemPaymentRecord: lineItemPaymentRecord.raw,
      });
    }
  }

  onPayableSelect(selectedRow) {
    const { payableRows, selectedPayable, } = this.state;
    if (!selectedPayable || selectedRow.id !== selectedPayable.id) {
      const payable = payableRows.find((row) => {
        const { raw, } = row;
        return raw.id === selectedRow.id;
      });
      this.setState({
        selectedPayable: payable.raw,
      });
    }
  }

  getLineItemPaymentRecordFooter(selectedLineItemPaymentRecord) {
    if (!selectedLineItemPaymentRecord) {
      return null;
    }
    return (
        <div className="container mt-2">
          <p>{`Selected ID: ${selectedLineItemPaymentRecord._id}`}</p>
          <hr />
          <div className="row">
            <div className="m-1">
              <IPBSLineItemPaymentRecordModal selectedLineItem={selectedLineItemPaymentRecord} />
            </div>
            <div className="m-1">
              <Button
                variant="primary"
                onClick={() => this.getPayable({ selectedLineItemPaymentRecord, })}
              >
                Payable
              </Button>
            </div>
          </div>
        </div>
    );
  }

  getPayableFooter(selectedPayable) {
    if (!selectedPayable) {
      return null;
    }
    return (
        <div className="container mt-2 pb-3">
          <p>{`Selected ID: ${selectedPayable.id}`}</p>
          <hr />
          <div className="row">
            <IPBSDetailedPayableModal selectedPayable={selectedPayable} />
          </div>
        </div>
    );
  }

  getPayable(row) {
    this.onPayableReset();
    const payable = row.selectedLineItemPaymentRecord.payableAtTimeOfPayment;
    const model = Grid.toModel(payable, {
      headerFormatter: value => _.startCase(value.header),
    });

    this.setState({
      payableHeaders: model.headers,
      payableRows: model.format([ payable, ]),
    });
  }

  render() {
    const {
      payableHeaders,
      payableRows,
      selectedPayable,
      lineItemPaymentRecordHeaders,
      lineItemPaymentRecordRows,
      selectedLineItemPaymentRecord,
    } = this.state;
    return (
        <div className="container">
          <SearchBar comboFields={this.comboFields} onClick={event => this.searchOnClick(event)} />
          <div className="mt-2">
            <FieldSet title="Line Item Payment Records" style={{ maxHeight: '300px', }}>
              <Grid
                headers={lineItemPaymentRecordHeaders}
                rows={lineItemPaymentRecordRows}
                onRowSelect={row => this.onRowSelect(row)}
              />
            </FieldSet>
            {this.getLineItemPaymentRecordFooter(selectedLineItemPaymentRecord)}
          </div>
          <div className="mt-2">
            <FieldSet title="Payable At Time Of Payment">
              <Grid
                headers={payableHeaders}
                rows={payableRows}
                onRowSelect={data => this.onPayableSelect(data)}
              />
            </FieldSet>
            {this.getPayableFooter(selectedPayable)}
          </div>
        </div>
    );
  }
}

IPBSView.propTypes = {
  serviceOfferingId: PropTypes.string.isRequired,
};

export default IPBSView;
